import { render, staticRenderFns } from "./TeacherTask.vue?vue&type=template&id=2b956940&scoped=true"
import script from "./TeacherTask.vue?vue&type=script&lang=js"
export * from "./TeacherTask.vue?vue&type=script&lang=js"
import style0 from "./TeacherTask.vue?vue&type=style&index=0&id=2b956940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b956940",
  null
  
)

export default component.exports